// import hooks
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';

// import props
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

export type TravelArrangementsProps = {
  employeeId: number;
};

export type TravelArrangementsData = {
  city?: string;
  comment?: string;
  compensationTypeId?: number;
  compensationTypeName?: string;
  countryCode?: {
    name: string;
    value: string;
  };
  distanceKm?: number;
  empId?: number;
  empTrvArrangementId?: number;
  houseNumber?: string;
  postalCode?: string;
  streetName?: string;
  arrangementTypes?: {
    id: number;
    name: string;
  };
  travelExpensesNominal?: number;
  trvSetDescription?: string;
  trvSetId?: number;
  trvSet?: {
    description: string;
    trvSetId: number;
  };
  valid?: {
    from: Date;
    to: Date;
  };
  waId?: number;
  waNr: {
    waId: string;
  };
};

export type ExtendedTravelArrangementsData = TravelArrangementsData & {
  uniqueId: string;
};

export enum TravelArrangementEnums {
  NO_COMPENSATION,
  VARIABLE_BASED_ON_ADDRESS,
  VARIABLE_BASED_ON_POSTAL_CODE,
  VARIABLE_BASED_ON_DISTANCE,
  VARIABLE_BASED_ON_DISTANCE_IN_SERVICE,
  FIXED_AMOUNT
}

export type TravelArrangementsFormProps = {
  rowData?: Partial<TravelArrangementsData>;
  employeeId: number;
  handleClose: () => void;
  isCopy?: boolean;
};

export type UseFormProps = {
  control: Control<any>;
  watch?: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
};

export type DateSectionProps = UseFormProps & {
  toDate: Date | undefined;
};

export type DistanceAndAmountSectionProps = UseFormProps & {
  isFieldHidden?: (field: string) => boolean | undefined;
};

export type LocationSectionProps = UseFormProps & {
  rowData: Partial<TravelArrangementsData>;
  isFieldHidden?: (field: string) => boolean | undefined;
};

export type ArrangementAndCompensationSectionProps = UseFormProps & {
  rowData: Partial<TravelArrangementsData>;
  employeeId: number;
  selectedArrangementType?: {
    id: number;
    name: string;
  };
};

export type CreateEditFormProps = FormComponentProps & {
  rowData: Partial<TravelArrangementsData>;
  employeeId: number;
  isCopy?: boolean;
  isDrawerOpen?: boolean;
};
